module.exports = __webpack_public_path__ + "static/media/loc3_img26.31a2073f.jpg";